import { Kpi, KpiGrid } from '@localina/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStatsChange } from './RestaurantStatsChange';

// Holds the hint line open on cards without a change to show, so every card is the same height.
const EMPTY_HINT = '\u00a0';

interface IFigures {
    numberOfGuests: number;
    numberOfReservations: number;
}

interface IProps {
    figures: IFigures;
    // Same figures a week earlier; when given, each card shows the change.
    previousWeekFigures?: IFigures;
}

// The fixed-width column left of a chart row; every row uses the same width so the charts line up.
export const RestaurantStatsFigures: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    const { changeHint, changeTone } = useStatsChange();

    const { numberOfGuests, numberOfReservations } = props.figures;
    const previous = props.previousWeekFigures;

    // The column is narrow and the hint is cut to one line, so the full text stays on hover.
    const hint = (current: number, before?: number): React.ReactNode => {
        const text = before !== undefined ? changeHint(current, before) : undefined;
        return text ? <span title={text}>{text}</span> : EMPTY_HINT;
    };

    return (
        <div className="restaurant-stats__figures">
            <KpiGrid columns={1}>
                <Kpi
                    label={t('dashboard.tile.fields.guests')}
                    value={numberOfGuests.toLocaleString()}
                    hint={hint(numberOfGuests, previous?.numberOfGuests)}
                    tone={previous && changeTone(numberOfGuests, previous.numberOfGuests)}
                />
                <Kpi
                    label={t('dashboard.tile.fields.reservations')}
                    value={numberOfReservations.toLocaleString()}
                    hint={hint(numberOfReservations, previous?.numberOfReservations)}
                    tone={previous && changeTone(numberOfReservations, previous.numberOfReservations)}
                />
            </KpiGrid>
        </div>
    );
};
